import {Component, input, output} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {Translations} from "@translations";
import {TranslateModule} from "@ngx-translate/core";
import {SimButton} from "@common/ui/button/sim-button.component";

@Component({
	selector: "sim-assessment-exam-info-header",
	standalone: true,
	imports: [MatIcon, SimButton, TranslateModule],
	templateUrl: "./assessment-exam-info-header.component.html",
	styleUrl: "./assessment-exam-info-header.component.scss",
})
export class AssessmentExamInfoHeaderComponent {
	protected readonly T = Translations;

	public readonly studentName = input.required<string>();
	public readonly studentEmail = input<string | null>(null);
	public readonly hasClinicalVignette = input<boolean>(false);

	public readonly onShowClinicalVignette = output<void>();
}
